module.exports = __webpack_public_path__ + "static/media/chat-dark.6c621d2d.svg";